module.exports = __webpack_public_path__ + "static/media/default-pick-medal-image.7cf435f5.svg";